import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Modal from '../../shared/modals/modal.component';

import {
  hideCategoryModalForDelete,
  deleteCategory,
} from './store/actions';

class DeleteCategoriesModal extends PureComponent {
  static propTypes = {
    hideCategoryModalForDelete: PropTypes.func.isRequired,
    deleteCategory: PropTypes.func.isRequired,

    period: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }).isRequired,

    categoryName: PropTypes.string,
    description: PropTypes.string,
    catView: PropTypes.string,
    defaultTag: PropTypes.string,
    isVisible: PropTypes.bool,
  };

  removeCategory = () => {
    const {
      deleteCategory,
      period,
      categoryName,
    } = this.props;

    deleteCategory({
      period,
      categoryName,
    });
  };

  render() {
    const {
      hideCategoryModalForDelete,
      period,
      description,
      categoryName,
      catView,
      defaultTag,
      isVisible,
    } = this.props;

    return (
      <Modal
        className="delete-category-modal"
        dismissText="Cancel"
        submitText="Yes"
        title="Delete Category"
        closeAction={hideCategoryModalForDelete}
        dismissAction={hideCategoryModalForDelete}
        submitAction={this.removeCategory}
        isVisible={isVisible}
      >
        <div>
          Are you sure you want to delete: <br/><br/>
          Category Name: {categoryName}<br/>
          Period: {period.name}<br/>
          Description: {description}<br/>
          Category View: {catView}<br/>
          Default Tag: {defaultTag}<br/>
        </div>
      </Modal>
    );
  }
}

export default connect(
  null,
  {
    hideCategoryModalForDelete,
    deleteCategory,
  }
)(DeleteCategoriesModal);
